import React, { useState, useEffect } from 'react';
import { Provider } from 'react-redux';
import {} from 'libs/api/user';
import { Link } from 'react-router-dom';
import { get } from 'lodash';
import configureStore from 'stores/configureStore';
import MenteeCard from 'components/mentoring/mentee/MenteeCard';
import MentoringCancelModal from 'components/mentoring/MentoringCancelModal';
import MentoringClassStatus from 'components/mentoring/MentoringClassStatus';
import { ClassViewCommon } from 'components/mentoring/MentoringClassView';
import MentoringPastClass from 'components/mentoring/MentoringPastClass';
import MentoringRejectModal from 'components/mentoring/MentoringRejectModal';
import { MentoringClassWrapper } from 'components/mentoring/styles';
import { showConfirm } from 'components/modal/showConfirm';
import { getMentoringClass, acceptMentoringClass } from 'libs/api/mentoring';
import { useDataApi } from 'libs/hooks';
import { showNotification } from 'libs/utils';
import { TMentoringClass } from 'modules/mentoring';
import { TModalState } from 'modules/types';
import { CWindowWidth } from 'constants/base.const';
import { CUserType } from 'constants/user.const';
import { EUserType } from 'enums/base.enum';
import { EMentoringClassStatus } from 'enums/mentoring.enum';
import { ERoute } from 'enums/route.enum';
import { Button, Col, Row, Typography, Form, Divider, Spin } from 'antd';
import { CheckOutlined } from '@ant-design/icons';

const { Text, Title } = Typography;
const MentorClassView = ({ recordId }: { recordId: number }) => {
  const [form] = Form.useForm();
  const getPromise = getMentoringClass.bind(null, recordId);
  const [{ data, loading }, setCallback] = useDataApi<TMentoringClass>(getPromise);
  const [mentoringCancelModal, setMentoringCancelModal] = useState<TModalState>({
    visible: false,
  });
  const [mentoringRejectModal, setMentoringRejectModal] = useState<TModalState>({
    visible: false,
  });
  const [acceptButtonDisabled, setAcceptButtonDisabled] = useState(false);
  const store = configureStore({});

  // console.log("멘토링 취소 버튼 눌렀을 때 setState 확인",mentoringCancelModal)
  useEffect(() => {
    if (data && !loading) {
      setCallback(() => getPromise);
    }
  }, [recordId]);

  useEffect(() => {
    const interval = setInterval(() => {
      window.location.reload();
    }, 60000)
    return () => {
      clearInterval(interval);
    };
  }, []);

  function handleRequestAccept() {
    showConfirm(
      async () => {
        try {
          setAcceptButtonDisabled(true);
          await acceptMentoringClass(recordId);
          setCallback(() => getPromise);
        } catch (e) {
          throw e;
        } finally {
          setAcceptButtonDisabled(false);
        }
      },
      <span style={{ fontWeight: 'bold' }}>수락하기</span>,
      <Provider store={store}>
        <MentoringClassWrapper>
          <MentoringClassStatus record={data} />
          <div>
            <img
              alt='profile_image'
              className='small-thumbnail-img'
              src={get(data, 'mentee.user.profile_image.absolute_url')}
            />
            <span style={{ marginLeft: '5px' }}>{get(data, 'mentee.user.fullname')} 멘티</span>
          </div>
          <div style={{ marginTop: '10px' }}>멘토링 신청을 수락하시겠습니까?</div>
        </MentoringClassWrapper>
      </Provider>,
    );
  }

  //   function handleRequestReject() {
  //     // console.log(recordId);
  //     showConfirm(
  //       async () => {
  //         try {
  //           await rejectMentoringClass(recordId);

  //           setCallback(() => getPromise);
  //         } catch (e) {
  //           throw e;
  //         }
  //       },
  //       //title
  //       <span style={{ fontWeight: "bold" }}>거절하기</span>,
  //       //content
  //       <Provider store={store} >
  //         <MentoringClassWrapper>
  //           <MentoringClassStatus record={data} />
  //           <div>
  //             <img
  //               className="small-thumbnail-img"
  //               src={get(data, "mentee.user.profile_image.absolute_url")}
  //             />
  //             <span style={{ marginLeft: "5px" }}>
  //               {get(data, "mentee.user.fullname")} 멘티
  //             </span>
  //           </div>
  //           <form style={{ marginTop: "10px" }}>
  //             멘토링 신청을 거절하시겠습니까?

  //             <FormWrapper style={{ padding: "20px 0px" }}>
  //               <Form form={form} layout="vertical" className="form-normal">
  //                 <Form.Item
  //                   name="memo"
  //                   className="form-item no-margin"
  //                   label="거절 사유를 적어주세요"
  //                   rules={[{ required: true }]}
  //                 >
  //                   <Input.TextArea
  //                     className="form_textarea"
  //                     placeholder="거절사유를 자세하게 적어주세요.
  // 예) 이번 시간이 적합하지 않아서 수업이 진행이 다소 어렵습니다. 홍길동님의 양해를 구합니다."
  //                     autoSize={{ minRows: 5 }}
  //                   />
  //                 </Form.Item>
  //               </Form>
  //             </FormWrapper>
  //             {/* <input placeholder="거절 사유를 적어주세요" /> */}

  //           </form>
  //         </MentoringClassWrapper>
  //       </Provider>
  //     );
  //   }

  return (
    <MentoringClassWrapper>
      <Spin tip='loading...' spinning={loading}>
        <Row
          style={{
            maxWidth: `${CWindowWidth - 300}px`,
            margin: '20px auto',
            padding: '30px 10px',
          }}
          gutter={[32, 16]}
        >
          <Col
            xs={{ span: 24, order: 2 }}
            sm={{ span: 24, order: 2 }}
            md={{ span: 17, order: 1 }}
            lg={{ span: 17, order: 1 }}
            xl={{ span: 17, order: 1 }}
          >
            <Title level={2} style={{ marginBottom: '0px' }}>
              멘토링 상세
            </Title>
            <Row justify='space-between' align='bottom' style={{ marginTop: '30px' }}>
              <Col>
                <MentoringClassStatus record={data} />
                {get(data, 'memo') && (
                  <div className='content-block' style={{ marginTop: '10px' }}>
                    {get(data, 'memo')}
                  </div>
                )}
              </Col>
              <Col>
                {get(data, 'status') === EMentoringClassStatus.RequestPending && (
                  <>
                    <Button
                      onClick={handleRequestAccept}
                      style={{ marginRight: '5px' }}
                      loading={acceptButtonDisabled}
                    >
                      수락하기
                    </Button>
                    <Button
                      // onClick={handleRequestReject}
                      onClick={() => {
                        // console.log("거절하기 버튼 누르면 모달 뜰 때 data", data);
                        setMentoringRejectModal({
                          visible: true,
                          record: data,
                          onFinish: () => {
                            setCallback(() => getPromise);
                            showNotification('success', '멘토링이 거절되었습니다.');
                          },
                        });
                      }}
                      danger
                    >
                      거절하기
                    </Button>
                  </>
                )}
                {get(data, 'status') === EMentoringClassStatus.RequestAccepted && (
                  <>
                    <Button
                      onClick={() => {
                        setMentoringCancelModal({
                          visible: true,
                          record: data,
                          onFinish: () => {
                            setCallback(() => getPromise);
                            showNotification('success', '멘토링이 취소되었습니다.');
                          },
                        });
                      }}
                      danger
                    >
                      멘토링 취소
                    </Button>
                  </>
                )}
                {get(data, 'status') === EMentoringClassStatus.Completed &&
                  get(data, 'is_attended') === true && (
                    <>
                      {get(data, 'is_feedback_completed') === true ? (
                        <Link to={`${ERoute.MentoringFeedback}/view/${get(data, 'feedback')}`}>
                          <Button style={{ marginRight: '5px' }}>
                            <CheckOutlined />
                            피드백 보기
                          </Button>
                        </Link>
                      ) : (
                        <>
                          {get(data, 'feedback') ? (
                            <Link
                              to={`${ERoute.MentoringFeedback}/edit/${get(data, 'feedback')}?id=${get(
                                data,
                                'id',
                              )}`}
                            >
                              <Button type='primary'>피드백 수정</Button>
                            </Link>
                          ) : (
                            <Link to={`${ERoute.MentoringFeedback}/create/?id=${get(data, 'id')}`}>
                              <Button type='primary' style={{ marginRight: '5px' }}>
                                피드백 쓰기
                              </Button>
                            </Link>
                          )}
                        </>
                      )}
                    </>
                  )}
              </Col>
            </Row>
            <Link
              className='small-profile'
              to={`${ERoute.MentoringMenteeView.replace(':record_id', String(get(data, 'mentee.id')))}`}
            >
              <img alt='profile_image' src={get(data, 'mentee.user.profile_image.absolute_url')} />
              <span>
                {get(data, 'mentee.user.fullname')} {CUserType[EUserType.Mentee]}
              </span>
            </Link>
            <ClassViewCommon record={data} />
            <Divider className='class-divider-32' />
            <div style={{ marginBottom: '10px' }} className='content-title'>
              멘티와의 지난 멘토링
            </div>
            {!loading && <MentoringPastClass withId={get(data, 'mentee.id')} targetType={EUserType.Mentee} />}
          </Col>
          <Col
            xs={{ span: 24, order: 1 }}
            sm={{ span: 24, order: 1 }}
            md={{ span: 6, offset: 1 }}
            lg={{ span: 6, offset: 1 }}
            xl={{ span: 6, offset: 1 }}
            style={{ textAlign: 'center' }}
          >
            {get(data, 'status') === EMentoringClassStatus.RequestAccepted ? (
              <MenteeCard
                mentee={get(data, 'mentee')}
                useInterested={false}
                meetingUrl={get(data, 'meeting_url')}
                sendbirdInfo={get(data, 'sendbird')}
                data={data}
              />
            ) : (
              <MenteeCard mentee={get(data, 'mentee')} useInterested={false} />
            )}
          </Col>
        </Row>
      </Spin>
      <MentoringCancelModal modalState={mentoringCancelModal} setModalState={setMentoringCancelModal} />
      <MentoringRejectModal modalState={mentoringRejectModal} setModalState={setMentoringRejectModal} />
    </MentoringClassWrapper>
  );
};

export default MentorClassView;
